import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/resources/', { params });
  },
  find({ resourceId = null, uniqueId = null }) {
    return Backend.get('/resources/view', { params: { resource_id: resourceId, unique_id: uniqueId } });
  },
  findResByUID(uid) {
    return Backend.get(`/r/${uid}`);
  },
  createData() {
    return Backend.get('/resources/create');
  },
  editData(id) {
    return Backend.get(`/resources/${id}/edit`);
  },
  create(data) {
    return Backend.post('/resources/', data);
  },
  update(data) {
    return Backend.put(`/resources/${data.id}`, data);
  },
  delete(id) {
    return Backend.delete(`/resources/${id}`);
  },
};
